import { schema } from 'normalizr'

const paymentSchema = new schema.Entity('payments')
const paymentsSchema = new schema.Array(paymentSchema)

export { paymentsSchema }

export default paymentSchema
